module.exports = __webpack_public_path__ + "static/img/icon-menu-resident.5daca7e.png";